import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HomeSection extends Vue {
  public imagesRefs: {[key: string]: string} = {};

  public headersRefs: {[key: string]: string} = {};

  public textsRefs: {[key: string]: string} = {};

  public imagesAppeareence = false;

  public headersAppearence = false;

  public textsAppearence = false;

  mounted(): void {
    this.prepareHeaders();
    this.startWatchingScroll();
    window.addEventListener('scroll', this.startWatchingScroll.bind(this));
  }

  destroyed(): void {
    window.removeEventListener('scroll', this.startWatchingScroll.bind(this));
  }

  private startWatchingScroll() {
    if (this.imagesAppeareence) {
      this.startImagesAppearing();
    }
    if (this.textsAppearence) {
      this.startTextsAppearing();
    }
    if (this.headersAppearence) {
      this.startHeadersAppearing();
    }
  }

  private startImagesAppearing(): void {
    const values: string[] = Object.values(this.imagesRefs).filter(Boolean);
    if (!values.length) {
      this.imagesAppeareence = false;
      return;
    }

    values.forEach((ref: string) => {
      const image: HTMLElement = this.getRef(ref);
      if (!image) return;
      const { top, bottom } = image.getBoundingClientRect() as DOMRect;

      const isVisible: boolean = (top >= 0)
        && (bottom <= (window.innerHeight || document.documentElement.clientHeight));

      if (isVisible) {
        this.imagesRefs[ref] = '';
        image.classList.add('bubble');
      }
    });
  }

  private startTextsAppearing(): void {
    const values: string[] = Object.values(this.textsRefs).filter(Boolean);
    if (!values.length) {
      this.textsAppearence = false;
      return;
    }

    values.forEach((ref: string) => {
      const text: HTMLElement = this.getRef(ref);
      if (!text) return;
      const { top, bottom } = text.getBoundingClientRect() as DOMRect;

      const isVisible: boolean = (top >= 0)
        && (bottom <= (window.innerHeight || document.documentElement.clientHeight));

      if (isVisible) {
        this.textsRefs[ref] = '';
        text.classList.add('appeared');
      }
    });
  }

  private startHeadersAppearing() {
    const values: string[] = Object.values(this.headersRefs).filter(Boolean);
    if (!values.length) {
      this.headersAppearence = false;
      return;
    }

    values.forEach((ref: string) => {
      const header: HTMLElement = this.getRef(ref);
      if (!header) return;
      const { top, bottom } = header.getBoundingClientRect() as DOMRect;

      const isVisible: boolean = (top >= 0)
        && (bottom <= (window.innerHeight || document.documentElement.clientHeight));

      if (isVisible) {
        header.querySelectorAll('span').forEach((e) => {
          e.classList.add('appeared');
        });
        header.style.opacity = '1';
      }
    });
  }

  private prepareHeaders() {
    const values: string[] = Object.values(this.headersRefs).filter(Boolean);
    if (!values.length) {
      this.headersAppearence = false;
      return;
    }

    values.forEach((ref: string) => {
      const header: HTMLElement = this.getRef(ref);
      if (!header) return;

      header.innerHTML = `<div>${
        (header.innerHTML || '')
          .replace('<br>', ' <br> ')
          .split(' ')
          .filter(Boolean)
          .map((word: string) => {
            if (word.includes('<br>')) return word;
            return `<span class="header--disappeared">${word} </span>`;
          })
          .join(' ')
      }</div>`;
    });
  }

  private getRef(ref: string): HTMLElement {
    if (this.$refs[ref] instanceof Array) {
      const refElList: HTMLElement[] = this.$refs[ref] as HTMLElement[];
      return refElList[0];
    }

    return this.$refs[ref] as HTMLElement;
  }
}
